import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { Contact } from 'v2/models';
import styles from 'v2/pages/DataVendorDetails/ContactTab/item.module.scss';
import { getContactNameToLink } from 'v2/utils/ContactUtils';

interface ContactItemProps {
  contact: Contact;
  backLinkTitle?: string;
}

const Item = ({ contact, backLinkTitle }: ContactItemProps) => {
  const renderedName = getContactNameToLink(contact);

  return (
    <div className={classnames(styles.itemContainer)}>
      <div className={classnames(styles.itemHeader)}>
        <Link
          to={{
            pathname: `/contact-details/${contact.id}/detail`,
            state: {
              counterToGoBack: -1,
              backLinkTitle: backLinkTitle || 'Back',
            },
          }}
          className={classnames(styles.contactName)}
        >
          {renderedName}
        </Link>
      </div>
      <div className={classnames(styles.itemDescription)}>
        {contact.title && <p>{contact.title}</p>}
        {contact.primary_associations?.email?.email && (
          <p>
            <a href={`mailto:${contact.primary_associations.email.email}`}>
              {contact.primary_associations.email.email}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export default Item;
